
<!--Below dic is for Model dialog box for showing image in big size box when use clicks the image-->
<div id="myModal22" style="text-align:center" class="modal fade" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" style="margin-top:-3%">
    <span class="close close_1" data-dismiss="modal">&times;</span>
    <div class="modal-content">
      <div class="modal-body">
        <img src="{{image}}" style=" width:100%;height:300%" />
      </div>
    </div>
  </div>
</div>

<div class="container bred_border">
  <div class="row page_mar_t">
    <div class="col-lg-10 col-md-10 col-sm-12 col-xs-12">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a routerLink="/Home">Home</a></li>
          <li class="breadcrumb-item"><a (click)="FilterList(CatID)" style="width: auto;cursor:pointer">Products</a></li>
          <li class="breadcrumb-item"><a (click)="FilterList(CatID)" style="width: auto;cursor:pointer">{{CategoryName}}</a></li>
          <li class="breadcrumb-item bread_active" aria-current="page">{{Specdata[0].ChemicalName}}</li>
        </ol>
      </nav>
    </div>

    <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 icons" style="padding-right: 0;">
          <a href="tel:09676308014">
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                 width="40" height="40"
                 viewBox="0 0 172 172"
                 style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g><path d="M72.5625,71.21875c0,8.33125 0,47.03125 0,47.03125h47.03125c25.93437,0 47.03125,-21.09687 47.03125,-47.03125c0,-25.93437 -21.09688,-47.03125 -47.03125,-47.03125c-25.93438,0 -47.03125,21.09688 -47.03125,47.03125z" fill="#ffffff"></path><path d="M10.48125,40.71563v0c-5.9125,29.5625 -5.9125,60.06563 0,89.62813v0v0c3.35938,16.93125 18.14063,29.15938 35.475,29.15938v0v0v0v0c4.43437,0 7.79375,-3.89688 7.25625,-8.33125l-3.225,-24.05313c-0.94063,-6.58438 -6.58438,-11.55625 -13.16875,-11.55625v0c-6.71875,0 -11.69062,1.74688 -11.69062,1.74688v-31.7125v-31.7125c0,0 5.10625,1.74688 11.69063,1.74688v0c6.71875,0 12.3625,-4.97188 13.16875,-11.55625l3.225,-24.05312c0.5375,-4.43438 -2.82187,-8.33125 -7.25625,-8.33125v0c-17.33437,0 -32.11562,12.09375 -35.475,29.025z" fill="#ffffff"></path><path d="M36.81875,59.52813c8.6,0 15.99062,-6.45 17.2,-15.05l3.225,-24.05312c0.40313,-3.225 -0.5375,-6.45 -2.6875,-9.00312c-2.15,-2.55312 -5.24062,-3.89687 -8.6,-3.89687c-19.21563,0.13438 -35.74375,13.70625 -39.50625,32.51875c-6.04687,30.23438 -6.04687,60.87187 0,91.10625c3.7625,18.8125 20.29062,32.38437 39.37187,32.38437c2.28438,0 4.03125,-1.74687 4.03125,-4.03125c0,-2.28438 -1.74687,-4.03125 -4.03125,-4.03125c-15.31875,0 -28.4875,-10.88437 -31.44375,-25.93437c-5.77813,-29.15938 -5.77813,-58.85625 0,-88.01562c2.95625,-15.05 16.25938,-25.93437 31.44375,-25.93437c1.34375,0 2.15,0.67188 2.41875,1.075c0.40312,0.40313 0.94062,1.34375 0.80625,2.55313l-3.225,24.05312c-0.67187,4.56875 -4.56875,8.0625 -9.27187,8.0625c-5.9125,0 -10.48125,-1.47812 -10.48125,-1.47812c-1.20937,-0.40312 -2.55312,-0.13438 -3.62812,0.5375c-1.075,0.80625 -1.6125,2.01563 -1.6125,3.225v66.1125c0,1.6125 0.94063,2.95625 2.28438,3.62813c1.34375,0.67188 3.09062,0.40312 4.3,-0.5375c0,0 4.3,-3.49375 9.1375,-3.49375c4.70313,0 8.6,3.49375 9.27187,8.0625l1.74688,12.63125c0.26875,2.01563 2.01563,3.49375 4.03125,3.49375c0.13437,0 0.40312,0 0.5375,0c2.15,-0.26875 3.7625,-2.28437 3.49375,-4.56875l-1.74688,-12.63125c-1.075,-8.33125 -8.46563,-14.78125 -17.06562,-14.78125c-2.82188,0 -5.50938,0.67188 -7.65938,1.47812v-54.01875c2.01563,0.26875 4.70312,0.5375 7.65938,0.5375z" fill="#444b54"></path><path d="M119.59375,122.28125h-47.03125c-2.28437,0 -4.03125,-1.74688 -4.03125,-4.03125v-47.03125c0,-28.21875 22.84375,-51.0625 51.0625,-51.0625c28.21875,0 51.0625,22.84375 51.0625,51.0625c0,28.21875 -22.84375,51.0625 -51.0625,51.0625zM76.59375,114.21875h43c23.65,0 43,-19.35 43,-43c0,-23.65 -19.35,-43 -43,-43c-23.65,0 -43,19.35 -43,43z" fill="#71c2ff"></path><path d="M133.03125,91.375h-33.59375c-2.28437,0 -4.03125,-1.74688 -4.03125,-4.03125c0,-2.28437 1.74688,-4.03125 4.03125,-4.03125h33.59375c2.28438,0 4.03125,1.74688 4.03125,4.03125c0,2.28437 -1.74687,4.03125 -4.03125,4.03125z" fill="#71c2ff"></path><path d="M133.03125,71.21875h-33.59375c-2.28437,0 -4.03125,-1.74688 -4.03125,-4.03125c0,-2.28437 1.74688,-4.03125 4.03125,-4.03125h33.59375c2.28438,0 4.03125,1.74688 4.03125,4.03125c0,2.28437 -1.74687,4.03125 -4.03125,4.03125z" fill="#71c2ff"></path><path d="M63.69375,163.53438c-2.28438,0 -4.03125,-1.74688 -4.03125,-4.03125c0,-2.28438 1.74687,-4.03125 4.03125,-4.03125c5.10625,0 9.80937,-2.01562 13.4375,-5.50938c0.80625,-0.80625 1.88125,-1.20937 2.95625,-1.20937c1.075,0 2.15,0.5375 2.95625,1.34375c2.41875,2.6875 5.77813,4.3 9.40625,4.3c3.62812,0.13438 6.9875,-1.20937 9.675,-3.89687l0.67188,-0.67187c1.6125,-1.6125 4.16562,-1.6125 5.64375,0l1.34375,1.34375c2.41875,2.41875 5.77812,3.89687 9.27188,3.89687c3.49375,0 6.85312,-1.34375 9.27187,-3.89687l1.34375,-1.34375c1.6125,-1.6125 4.16563,-1.6125 5.64375,0l6.71875,6.71875c1.6125,1.6125 1.6125,4.16563 0,5.64375c-1.6125,1.6125 -4.16562,1.6125 -5.64375,0l-3.89687,-3.89688c-3.7625,3.09063 -8.46563,4.70313 -13.30313,4.70313c-4.97188,0 -9.675,-1.74687 -13.57187,-4.8375c-3.7625,2.82187 -8.33125,4.3 -13.30313,4.16562c-4.56875,-0.13437 -8.73437,-1.6125 -12.22813,-4.3c-4.97188,3.62812 -10.48125,5.50938 -16.39375,5.50938z" fill="#444b54"></path></g></g></svg>
          </a>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 icons">
          <a href=" https://api.whatsapp.com/send?phone=9676308014&amp;text=Chat with our Experts." class="float" target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                 width="40" height="40"
                 viewBox="0 0 172 172"
                 style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g id="Layer_1"><path d="M86,165.28125c43.67188,0 79.28125,-35.60937 79.28125,-79.28125c0,-21.23125 -8.19688,-41.11875 -23.24687,-56.03437c-14.91563,-15.05 -34.80313,-23.24687 -56.03438,-23.24687c-43.67187,0 -79.28125,35.475 -79.28125,79.28125c0,13.975 3.62813,27.54688 10.61563,39.64063l-7.525,27.68125c-1.6125,5.9125 3.7625,11.42188 9.80938,9.80937l28.62188,-7.525c11.42187,6.31563 24.45625,9.675 37.75937,9.675z" fill="#ffffff"></path><path d="M86,149.15625c-10.48125,0 -20.9625,-2.6875 -30.23437,-7.65938c-2.41875,-1.34375 -5.10625,-2.01562 -7.65938,-2.01562c-1.34375,0 -2.6875,0.13438 -4.03125,0.5375l-15.05,3.89687l3.89687,-14.10937c1.075,-4.16562 0.5375,-8.6 -1.6125,-12.3625c-5.64375,-9.54063 -8.46562,-20.425 -8.46562,-31.44375c0,-34.9375 28.35313,-63.15625 63.15625,-63.15625c16.93125,0 32.7875,6.58437 44.74687,18.54375c11.825,11.825 18.40938,27.68125 18.40938,44.6125c0,34.80313 -28.35312,63.15625 -63.15625,63.15625z" fill="#5bf979"></path><path d="M144.99063,27.14375c-15.72187,-15.72187 -36.68438,-24.45625 -58.99062,-24.45625c-45.95625,0 -83.3125,37.35625 -83.3125,83.3125c0,14.10938 3.49375,27.95 10.34687,40.17813l-7.12187,26.06875c-1.20938,4.16562 0,8.46562 3.09062,11.55625c3.09063,3.09063 7.39063,4.3 11.55625,3.225l27.14375,-7.12187c11.825,6.18125 24.99375,9.40625 38.43125,9.40625c45.95625,0 83.3125,-37.35625 83.3125,-83.3125c-0.13438,-22.17188 -8.73437,-43.13438 -24.45625,-58.85625zM86,161.25c-12.49688,0 -24.99375,-3.225 -36.0125,-9.1375c-0.5375,-0.26875 -1.20938,-0.5375 -1.88125,-0.5375c-0.40312,0 -0.67187,0 -1.075,0.13438l-28.62187,7.525c-2.01562,0.5375 -3.35937,-0.5375 -3.89687,-1.075c-0.5375,-0.5375 -1.6125,-1.88125 -1.075,-3.89687l7.525,-27.68125c0.26875,-1.075 0.13438,-2.15 -0.40312,-3.09062c-6.45,-11.2875 -9.80938,-24.32187 -9.80938,-37.49062c0,-41.52187 33.72813,-75.25 75.25,-75.25c20.15625,0 39.10312,7.79375 53.2125,22.0375c14.24375,14.24375 22.17188,33.19063 22.0375,53.2125c0,41.52188 -33.72812,75.25 -75.25,75.25z" fill="#444b54"></path><g fill="#006475"><path d="M124.83438,114.35313c-1.6125,4.56875 -9.675,9.1375 -13.4375,9.40625c-3.62813,0.26875 -6.9875,1.6125 -23.78438,-4.97187c-20.15625,-7.92813 -32.92187,-28.62188 -33.8625,-29.96563c-0.94063,-1.34375 -8.0625,-10.75 -8.0625,-20.55937c0,-9.80938 5.10625,-14.5125 6.9875,-16.52813c1.88125,-2.01562 3.89687,-2.41875 5.24062,-2.41875c1.34375,0 2.6875,0 3.7625,0c1.47812,0 2.95625,0.13437 4.43437,3.35938c1.74687,3.89687 5.64375,13.70625 6.04688,14.64688c0.5375,0.94062 0.80625,2.15 0.13438,3.49375c-0.67187,1.34375 -0.94063,2.15 -2.01562,3.35938c-0.94063,1.20938 -2.15,2.55313 -2.95625,3.49375c-0.94062,0.94063 -2.01562,2.01563 -0.80625,4.03125c1.20938,2.01563 5.10625,8.46563 11.01875,13.70625c7.525,6.71875 13.975,8.86875 15.99063,9.80938c2.01563,0.94062 3.09063,0.80625 4.3,-0.5375c1.20937,-1.34375 4.97187,-5.77813 6.31562,-7.79375c1.34375,-2.01562 2.6875,-1.6125 4.43438,-0.94062c1.88125,0.67188 11.55625,5.50937 13.57187,6.45c2.01563,0.94063 3.35938,1.47812 3.7625,2.28438c0.5375,1.075 0.5375,4.97187 -1.075,9.675z"></path></g></g></g></svg>
          </a>

        </div>
      </div>

    </div>
  </div>
</div>
<br /><br />

<div class="container">
  <!--<div class="row">
    <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10">
      <h3 class="product_info_heading">{{Specdata[0].ChemicalName}}</h3>
    </div>
    <div class="col-lg-2 col-md-2 col-sm-10 col-xs-10 text_align_r" style="padding-top: 0.5rem;">
      <ul class="icons_ul">
        <li>
          <img src="https://img.icons8.com/ios-glyphs/20/000000/share--v1.png" class="padding_1" />
        </li>
      </ul>
    </div>
  </div>-->



  <div class="row">

    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
      <div class="row">

        <p-galleria [(value)]="Uimages" [responsiveOptions]="responsiveOptions" [containerStyle]="{'max-width': '640px'}" [numVisible]="4"
                    thumbnailsPosition="left">
          <ng-template pTemplate="item" let-item>
            <!--<ngx-image-zoom [thumbImage]=myThumbnail
                        [fullImage]=myFullresImage
                        [magnification]="1"
                        [enableScrollZoom]="true"
                        [enableLens]="true"
                        [lensWidth]="200"></ngx-image-zoom>
            (mouseenter)="imageZoom('myimage','myresult');"
            -->
            <div class="img-zoom-container" style="width: 100%;height:100%;cursor:pointer">
              <img (click)="showModal(HomeURL+item.ProductImage)" id="myimage" src="{{HomeURL+item.ProductImage}}" width="100%" height="412" />
            </div>
          </ng-template>
          <ng-template pTemplate="thumbnail" let-item>
            <div class="p-grid p-nogutter p-justify-center imgDiv">
              <img [src]="HomeURL+item.ProductImage" style="width: 100%; display: block;" />
            </div>
          </ng-template>
        </p-galleria>
        <!--<div class="col-lg-2 col-md-2" style="padding:0" >
          <div class="imgDiv" *ngFor="let item of Uimages let i=index">
            <img class="zImg demo" src="{{HomeURL+item.ProductImage}}" (click)="currentSlide(i)" height="100%" width="100%" />
          </div>
        </div>
        <div class="col-lg-10 col-md-10">
          <div class="img-zoom-container mySlides" (mouseenter)="imageZoom('myimage', 'myresult');">
            <img id="myimage" src="{{HomeURL+Image1}}" width="100%" height="100%">
          </div>
          <div id="myresult" class="img-zoom-result"></div>
        </div>
        <div class="caption-container">
          <p id="caption"></p>
        </div>-->

      </div>

    </div>

    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" *ngFor="let item of Specdata ; let i=index">
      <div>
        <span class="product_heading">{{item.Catalog_No}} - {{item.ChemicalName}}</span>
      </div>
      <div style="padding-left:0px;display: inline-block">
        <button on style="background-color:cornflowerblue; width: auto;" class="f_button btn-warning" (click)="addToCart(item,item.Pack1)" *ngIf="item.Pack1!=''">{{item.Pack1.toUpperCase()}}</button>

        <button on style="background-color:cornflowerblue; width: auto;" class="f_button btn-warning" (click)="addToCart(item,item.Pack2)" *ngIf="item.Pack2!=''">{{item.Pack2.toUpperCase()}}</button>
        <button on style="background-color:cornflowerblue; width: auto;" class="f_button btn-warning" (click)="addToCart(item,item.Pack3)" *ngIf="item.Pack3!=''">{{item.Pack3.toUpperCase()}}</button>

        <button on style="background-color:cornflowerblue; width: auto;" class="f_button btn-warning" (click)="addToCart(item,item.Pack4)" *ngIf="item.Pack4!=''">{{item.Pack4.toUpperCase()}}</button>
        <button on style="background-color:cornflowerblue; width: auto;" class="f_button btn-warning" (click)="addToCart(item,item.Pack5)" *ngIf="item.Pack5!=''">{{item.Pack5.toUpperCase()}}</button>

        <button on style="background-color:cornflowerblue; width: auto;" class="f_button btn-warning" (click)="addToCart(item,item.Pack6)" *ngIf="item.Pack6!=''">{{item.Pack6.toUpperCase()}}</button>
      </div>
      <br /><br />
      <span><button type="button" class="btn btn-secondary" (click)="addtoEnquiry(item)">ADD TO ENQUIRY</button></span> <span><button type="button" class="btn back_button" (click)="FilterList(CatID)">BACK TO PRODUCTS</button></span>
      <br /><br />
      <span class="product_text" *ngIf="item.ProductDesc == '' || item.ProductDesc == null">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</span>
      <span class="product_text">{{item.ProductDesc}}</span>
      <br /><br />
      <div class="row">
        <div class="col-lg-9 col-sm-9">
          <span *ngIf="item.ProductPdf != ''" style="margin-left:15px;">
            <a href="{{HomeURL+item.ProductPdf}}" target="_blank">
              <i class="fa fa-file-pdf-o" style="color: #ed1c24;" aria-hidden="true"></i>&nbsp;Download Brochure
            </a>
          </span>
        </div>

        <div class="col-lg-3 col-sm-3">
          <!--<div style="margin-left:300px;"><b>Share :</b>&nbsp; <span><i class="fa fa-facebook-square" aria-hidden="true"></i></span> &nbsp;&nbsp;<span> <i class="fa fa-whatsapp" aria-hidden="true"></i></span></div>-->


          <div class="row">

            <b>Share :</b>
            <div class="col-lg-1">
              <a (click)="sendWhatsapp(item)" style="cursor:pointer" class="float" target="_blank">
                <span> <i class="fa fa-whatsapp" aria-hidden="true"></i></span>
              </a>
              <!--<a href=" https://api.whatsapp.com/send?phone=9676308014&amp;text=Chat with our Experts." class="float" target="_blank">
                <span> <i class="fa fa-whatsapp" aria-hidden="true"></i></span>
              </a>-->
            </div>
            <div class="col-lg-1">
              <a class="fb-ic" href="https://www.facebook.com/klsindia/" target="_blank">
                <span><i class="fa fa-facebook-square" aria-hidden="true"></i></span>
              </a>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</div>


<style>
  tr.break td {
    height: 10px;
  }

  .pad_c {
    padding: 5px;
  }



  .ptxt {
    font-size: 12px;
    letter-spacing: 0.5px;
    line-height: 25px;
    text-align: justify;
  }

  .card {
    padding: 5px;
    box-shadow: 0 2px 5px 0 rgba(0,0,0,0.16), 0 2px 10px 0 rgba(0,0,0,0.12);
    margin-left: 5rem;
    margin-right: 5rem;
  }

  .card_style {
    background-color: #ffffff;
    color: #333333;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
    padding-left: 2% !important;
    border-radius: 0 !important;
  }

  .img-zoom-container {
    position: relative;
  }

  * {
    box-sizing: border-box;
  }

  .img-zoom-lens {
    position: absolute;
    border: 1px solid #d4d4d4;
    /*set the size of the lens:*/
    width: 40px;
    height: 40px;
  }








  .img-zoom-result {
    border: 1px solid #d4d4d4;
    /*set the size of the result div:*/
    width: 600px;
    height: 400px;
  }


  .img-zoom-lens {
    /*position: absolute;*/
    border: 1px solid #d4d4d4;
    /*set the size of the lens:*/
    width: 40px;
    height: 40px;
  }

  .img-zoom-result {
    border: 1px solid #d4d4d4;
    /*set the size of the result div:*/
    width: 600px;
    height: 350px;
    margin-top: -15rem;
    position: absolute;
    z-index: 99;
    margin-left: 25rem;
    border-radius: 10px;
  }




  .oval {
    background-color: #26a541;
    color: white;
    width: 40px;
    height: 20px;
    text-align: center;
    border-radius: 35px;
    text-transform: capitalize;
  }

  div.sticky {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    padding-bottom: 3rem;
    margin-top: 2%;
  }

  .h1_9 {
    color: #0b5ec6;
    font-size: 14px;
    letter-spacing: 0.5px;
  }
</style>
